package com.icebyte.printprofiletracker

import kotlinx.browser.document
import kotlinx.coroutines.suspendCancellableCoroutine
import org.w3c.dom.HTMLInputElement
import kotlin.coroutines.resume

actual suspend fun pickFiles(accept: String, multiple: Boolean): Array<Any>? =
    suspendCancellableCoroutine { cont ->
        val input = document.createElement("input") as HTMLInputElement
        input.type = "file"
        input.accept = accept
        input.multiple = multiple
        input.style.display = "none"
        input.onchange = {
            val files = input.files
            input.remove()
            cont.resume(
                if (files != null && files.length > 0) {
                    Array(files.length) { i -> files.item(i) as Any }
                } else null
            )
        }
        input.oncancel = {
            input.remove()
            cont.resume(null)
        }
        document.body?.appendChild(input)
        input.click()
    }
